module.exports = __webpack_public_path__ + "static/shifters2-d211fecb5896afd958008625ef0e51f6.png";